.link {
  text-decoration: none;
  color: var(--color-text-link);
}
